export const convertToNearstCrore = (value: number) => {
  const croreValue = value / 10000000;

  const roundedValue = Math.floor(croreValue * 10) / 10; // Round to one decimal place
  return roundedValue; // Return as a string with one decimal place
};
